import React, { useEffect, useRef, useState } from "react";
import { FieldArray, FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as jnb from "react-bootstrap";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import AdmissionResultAnalysisReport from "./AdmissionResultAnalysisReport";
import { FaTrash } from "react-icons/fa";
const NewAdditonalSection = ({ typee }) => {
    const [course, setCourse] = useState({});
    const [mergeStatus, setMergeStatus] = useState(false);
    const [showEditTable, setShowEditTable] = useState(false);
    const [enhanceStatus, setEnhanceStatus] = useState(false);
    const [paymentDone, setPaymentDone] = useState(false);
    const [courseData, setCourseData] = useState([]);
    const [totalSections, setTotalSections] = useState(0);
    const college=sessionStorage.getItem("user_id")
    const initialValues = {
        selectedCourses: [],
        intakeDetails: [],
        courseChangeDetails: [
            {
                existing_course: "",
                existing_intake: "",
                proposed_change_name: "",
                revised_intake: "",
                nature: "",
                course_cat_id: "",
                amount: "",
                section_no: ""
            },
        ],
    };
    const validationSchema = Yup.object().shape({
        courseChangeDetails: Yup.array().of(
            Yup.object().shape({
                existing_course: Yup.string().required(ERROR_MSG),
                existing_intake: Yup.string().required(ERROR_MSG),
                proposed_change_name: typee === "close" ? Yup.mixed().notRequired() : Yup.mixed().required(ERROR_MSG),
            }),
        ),
    });
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to save the details?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, save it!",
                cancelButtonText: "No, cancel",
            }).then((result) => {
                if (result.isConfirmed) {
                    const payload = {
                        intakeType: "Merger",
                        changecloselist: values.courseChangeDetails.map((item) => ({
                            courseId: parseInt(item.existing_course),
                            courseGrcode: item.course_group_code, 
                            courseType: item.course_cat_id, 
                            existingIntake: parseInt(item.existing_intake) || 0,
                            proposedName: item.proposed_change_name,
                            revisedIntake: parseInt(item.revised_intake) || 0,
                            nature: "Merger",
                            justification: values.justification,
                        })),
                    };
                    const url = `${config.url.FAC_URL}saveIntakeChanges`;
                    CommonAxiosPost(url, payload)
                        .then((res) => {
                            if (res?.data?.scode === "01") {
                                Swal.fire({
                                    title: res.data.sdesc,
                                    icon: "success",
                                    backdrop: false,
                                    confirmButtonText: "OK",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        GetIntakeDetails();
                                    }
                                });
                            } else {
                                Swal.fire({
                                    text: res.data?.sdesc,
                                    icon: "warning",
                                });
                            }
                        })
                        .catch((err) => {
                            console.error("Submission Error:", err);
                            Swal.fire({
                                text: "An error occurred during submission.",
                                icon: "error",
                            });
                        });
                }
            });
        },
    });
    useEffect(() => {
        const total = values.courseChangeDetails.reduce((sum, row) => {
            const sections = Number(row.section_no) || 1;
            const additional = Number(row.proposed_change_name) || 0;
            return sum + sections + additional;
        }, 0);
        setTotalSections(total);
    }, [formik.values.courseChangeDetails]);
    const handleSelectAll = (e) => {
        if (paymentDone) {
            Swal.fire({ icon: "warning", text: "Already Edited" });
            return;
        } else {
            if (e.target.checked) {
                if (courseData.length > 3) {
                    Swal.fire({
                        icon: "warning",
                        text: "You cannot select all because only 3 courses are allowed for modification. Please select up to 3 manually.",
                    });
                    return;
                }
                const allIds = courseData.map((c) => c.sno);
                setFieldValue("selectedCourses", allIds);
            } else {
                setFieldValue("selectedCourses", []);
            }
        }
    };
    const handleRowSelect = (sno, checked) => {
        if (paymentDone) {
            Swal.fire({ icon: "warning", text: "Already Edited" });
            return;
        }
        if (checked) {
            if (values.selectedCourses.length >= 3) {
                Swal.fire({
                    icon: "warning",
                    text: "You can select a maximum of 3 courses for modification.",
                });
                return;
            }
            setFieldValue("selectedCourses", [...values.selectedCourses, sno]);
        } else {
            const updatedSelectedCourses = values.selectedCourses.filter(
                (id) => id !== sno
            );
            setFieldValue("selectedCourses", updatedSelectedCourses);
            const removedCourse = courseData.find((c) => c.sno === sno);
            if (removedCourse) {
                const updatedCourseChangeDetails =
                    values.courseChangeDetails.filter(
                        (item) =>
                            Number(item.existing_course) !==
                            Number(removedCourse.course_id)
                    );
                const updatedIntakeDetails =
                    values.intakeDetails.filter(
                        (item) =>
                            Number(item.course_id) !==
                            Number(removedCourse.course_id)
                    );
                setFieldValue(
                    "courseChangeDetails",
                    updatedCourseChangeDetails
                );
                setFieldValue(
                    "intakeDetails",
                    updatedIntakeDetails
                );
                if (updatedCourseChangeDetails.length === 0) {
                    setShowEditTable(false);
                }
            }
        }
    };
    /* EDIT */
    const handleEdit = () => {
        const allSelectedRows = courseData.filter((course) =>
            values.selectedCourses.includes(course.sno)
        );
        const existingIds = values.courseChangeDetails.map(detail =>
            Number(detail.existing_course)
        );
        const selectedRows = allSelectedRows.filter(row =>
            !existingIds.includes(Number(row.course_id))
        );
        if (selectedRows.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "No new courses selected. Selected courses are already in the table.",
            });
            return;
        }
        const existingRows = values.courseChangeDetails.filter(
            row => row.existing_course
        ).length;
        if (existingRows + selectedRows.length > 3) {
            Swal.fire({
                icon: "warning",
                title: "Limit Reached",
                text: `Only 3 additional section requests can be added. You already have ${existingRows} and trying to add ${selectedRows.length}.`,
            });
            return;
        }
        const hasExistingData = values.courseChangeDetails.length > 0 &&
            values.courseChangeDetails.some(detail => detail.existing_course);
        if (hasExistingData) {
            const newChangeData = selectedRows.map((c) => ({
                existing_course: c.course_id,
                existing_intake: c.intake,
                proposed_change_name: "",
                revised_intake: "",
                nature: "",
                course_group_code: c.course_group_code,
                course_type: c.course_noc_type,
                section_no: c.section_no,
                existing_stream_desc: c.course_group_desc,
                existing_single_major_name: c.course_cat_name,
                existing_branch_name: c.course_name,
                amount: "10000"
            }));
    
            const newIntakeData = selectedRows.map((c) => ({
                sno: c.sno,
                course_id: c.course_id,
                course_name: c.course_name,
                intake: c.intake,
                course_cat_id: c.course_cat_id,
                course_cat_name: c.course_cat_name,
                course_group_code: c.course_group_code,
                course_group_desc: c.course_group_desc,
                course_type: c.course_noc_type,
                change_value: "",
                effective: "",
                aicte_ref: "",
                section_no: ""
            }));
            setFieldValue("courseChangeDetails", [
                ...values.courseChangeDetails,
                ...newChangeData
            ]);
            setFieldValue("intakeDetails", [
                ...values.intakeDetails,
                ...newIntakeData
            ]);
        } else {
            const data = selectedRows.map((c) => ({
                sno: c.sno,
                course_id: c.course_id,
                course_name: c.course_name,
                intake: c.intake,
                course_cat_id: c.course_cat_id,
                course_cat_name: c.course_cat_name,
                course_group_code: c.course_group_code,
                course_group_desc: c.course_group_desc,
                change_value: "",
                effective: "",
                aicte_ref: "",
                section_no: ""
            }));
            setFieldValue("intakeDetails", data);
            const changeData = selectedRows.map((c) => ({
                existing_course: c.course_id,
                existing_intake: c.intake,
                proposed_change_name: "",
                revised_intake: "",
                nature: "",
                course_group_code: c.course_group_code,
                course_type: c.course_noc_type,
                section_no: c.section_no,
                existing_stream_desc: c.course_group_desc,
                existing_single_major_name: c.course_cat_name,
                existing_branch_name: c.course_name,
                amount: "10000",
            }));
            setFieldValue("courseChangeDetails", changeData);
        }
        setShowEditTable(true);
        const el = document.getElementById("editTable");
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    //  ********** field array get api************
    const [count, setCount] = useState([])
    const GetIntakeDetails = (typee) => {
        const intakeType = typee === "course" ? "NameChange" : typee === "merger" ? "Merger" : "Closure";
        const url = `${config.url.FAC_URL}getInputDetails/${"Merger"}/${college}`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.namechange_status && Array.isArray(res.data.namechange) && res.data.namechange.length > 0) {
                    setMergeStatus(res.data.namechange_status);
                    setCount(res.data.namechange.length)
                    console.log("res.data.namechange.length", res.data.namechange.length)
                    console.log("Full API Response:", res.data);
                    setEnhanceStatus(true);
                    const mappedData = res.data.namechange.map((item) => {
                        const originalCourse = courseData.find(
                            (c) => Number(c.course_id) === Number(item.course_id_old)
                        );
                        return {
                            existing_course: Number(item.course_id_old),     
                            existing_intake: Number(item.existing_intake),
                            section_no: item.section_no ?? originalCourse?.section_no ?? "",
                            existing_stream_desc: originalCourse?.course_group_desc || item.course_group_desc || "",
                            existing_single_major_name: originalCourse?.course_cat_name || item.course_cat_name_old || "",
                            existing_branch_name: originalCourse?.course_name || item.course_name_old || "",
                            proposed_stream: item.course_group_code ? Number(item.course_group_code) : "",
                            proposed_single_major: item.course_cat_id ? Number(item.course_cat_id) : "",
                            proposed_change_name: item.course_id ? Number(item.course_id) : "",   
                            revised_intake: Number(item.revised_intake) || 0,
                            nature: item.nature ?? "",
                            amount: "10000",
                        };
                    });
                    formik.setFieldValue("courseChangeDetails", mappedData);
                    const intakeDetails = res.data.namechange
                        .map((item) => {
                            const course = courseData.find((c) => c.course_id === item.course_id);
                            return {
                                sno: course?.sno || null,
                                course_id: item.course_id,
                                course_name: course?.course_name || "",
                                intake: item.existing_intake,
                                course_cat_id: course?.course_cat_id,
                                course_cat_name: course?.course_cat_name,
                                course_group_code: course?.course_group_code,
                                course_group_desc: course?.course_group_desc,
                                course_type: course?.course_noc_type,
                                change_value: item.proposed_name,
                                effective: item.revised_intake,
                                aicte_ref: item.nature,
                                section_no: item.section_no
                            };
                        })
                        .filter((row) => row.sno); 
                    formik.setFieldValue("intakeDetails", intakeDetails);
                    setShowEditTable(true); 
                } else {
                    setMergeStatus(false);
                    setEnhanceStatus(false);
                    formik.setFieldValue("courseChangeDetails", [
                        {
                            existing_course: "",
                            existing_intake: "",
                            proposed_change_name: "",
                            revised_intake: "",
                            nature: "",
                            section_no: ""
                        },
                    ]);
                    formik.setFieldValue("intakeDetails", []);
                    formik.setFieldValue("justification", "");
                    setShowEditTable(false);
                }
            })
            .catch((err) => {
                console.error("Error fetching intake details:", err);
            });
    };

    useEffect(() => {
        if (typee) {
            GetIntakeDetails(typee);
        }
    }, [typee, courseData]);
    useEffect(() => {
        GetCourseDetails();
    }, [])
    const formikRef = useRef();
    useEffect(() => {
        formik.setFieldValue("selectedCourses", []);
        formik.setFieldValue("intakeDetails", []);
        formik.setFieldValue("courseChangeDetails", [
            {
                existing_course: "",
                existing_intake: "",
                proposed_change_name: "",
                revised_intake: "",
                nature: "",
                course_cat_id: "",
                section_no: ""
            },
        ]);
        // ✅ Clear justification
        formik.setFieldValue("justification", "");

        // ✅ Hide edit section
        setShowEditTable(false);
        setEnhanceStatus(false);
        setMergeStatus(false);
    }, [typee]);
    const { values, setFieldValue } = formik;
    function GetCoursesByProgramType(course_group_code, index) {
        if (!course_group_code) return;

        let url = `${config.url.FAC_URL}getSpecilization/${course_group_code}`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setCourse((prev) => ({
                    ...prev,
                    [index]: res.data.Specilization || [],
                }));
            } else {
                setCourse((prev) => ({
                    ...prev,
                    [index]: [],
                }));
            }
        });
    }
    // useEffect(() => {
    //   const timer = setTimeout(() => {
    //     values.courseChangeDetails.forEach((row, index) => {
    //       if (row.course_cat_id) {
    //         GetCoursesByProgramType(row.course_cat_id, index);
    //       }
    //     });
    //   }, 500); // wait 500ms after typing stops
    //   return () => clearTimeout(timer);
    // }, [values.courseChangeDetails]);
    useEffect(() => {
        const course_cat_id = formik.values.intakeDetails.map((item) => item.course_cat_id).join(",");


        // ✅ CALL API HERE
        formik.values.intakeDetails.forEach((row, index) => {
            if (row.course_cat_id) {
                GetCoursesByProgramType(row.course_cat_id, index);
            }
        });

        values.courseChangeDetails.forEach((row, index) => {
            if (row.course_cat_id) {
                GetCoursesByProgramType(row.course_cat_id, index);
            }
        });
    }, [values.courseChangeDetails, formik.values.intakeDetails]);
    function GetCourseDetails() {
        const url = `${config.url.FAC_URL}getCourseIntakeList`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.status === true && res?.data?.list?.length > 0) {
                    setCourseData(res?.data?.list);
                } else {
                    setCourseData([]);
                }
            })
            .catch((err) => {
                console.error("API Fetch Error:", err);
            });
    }
    const isCourseAlreadyAdded = (courseId) => {
        return values.courseChangeDetails.some(
            (detail) => Number(detail.existing_course) === Number(courseId)
        );
    };
    const hasValidSelection = values.selectedCourses.some(sno => {
        const course = courseData.find(c => c.sno === sno);
        return course && !isCourseAlreadyAdded(course.course_id);
    });
    return (
        <>
            <AdmissionResultAnalysisReport />
            <h5 className="mb-3 innerheader-new">
                <span> {typee === "additional" ? "New Additional Section" : "Additional Section"}</span>
            </h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead className="table-primary">
                        <tr>
                            <th>
                                {!paymentDone ? (
                                    <>
                                        <input type="checkbox" checked={courseData.length > 0 && values.selectedCourses.length === courseData.length} onChange={handleSelectAll} /> SL.No
                                    </>
                                ) : (
                                    "SL.No"
                                )}
                            </th>
                            <th>Academic Program Type</th>
                            <th>Name of the Single Major </th>
                            <th>Branch/Specialization</th>
                            <th>Medium</th>
                            <th>Section Number</th>
                            <th>Regular/Self Financed</th>
                            <th>Permanent/Temporary</th>
                            <th>Intake</th>
                        </tr>
                    </thead>
                    <tbody>
                        {courseData.length > 0 ? (
                            courseData.map((course, index) => (
                                <tr key={course.sno}>
                                    <td>
                                        <td>
                                            {!paymentDone ? (
                                                [86, 87, 89].includes(course.course_cat_id) ? (
                                                    // For restricted courses - show only number, no checkbox
                                                    <span>{index + 1}</span>
                                                ) : (
                                                    <>
                                                        <input
                                                            type="checkbox"
                                                            checked={isCourseAlreadyAdded(course.course_id) ? true : values.selectedCourses.includes(course.sno)}
                                                            onChange={(e) => handleRowSelect(course.sno, e.target.checked)}
                                                            disabled={isCourseAlreadyAdded(course.course_id)}
                                                        />
                                                        {index + 1}
                                                        {/* {isCourseAlreadyAdded(course.course_id) && <span className="text-muted ms-1">(Added)</span>} */}
                                                    </>
                                                )
                                            ) : (
                                                index + 1
                                            )}
                                        </td>
                                    </td>
                                    {console.log("course1111111", courseData)}
                                    <td>{course.course_group_desc}</td>
                                    <td>{course.course_cat_name}</td>
                                    <td>{course.course_name}</td>
                                    <td>{course.medium_name || "-"}</td>
                                    <td>{course.section_no || "-"}</td>
                                    <td>{course.reg_self === "S" ? "Self Finance" : course.reg_self === "R" ? "Regular" : ""}</td>
                                    <td>{course.course_noc_type}</td>
                                    <td>{course.intake}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center text-danger fw-bold">
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot className="table-secondary">
                        <tr>
                            <td colSpan="8" className="text-end fw-bold">Total Intake:</td>
                            <td className="fw-bold text-center">
                                {courseData.reduce((sum, course) => sum + (Number(course.intake) || 0), 0)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* enhanceStatus */}
            {!paymentDone && (
                <div className="d-flex justify-content-end mt-4">
                    {/* disabled={!values.selectedCourses.length} */}
                    <button type="button" className="btn btn-primary" onClick={handleEdit} 
                     disabled={!hasValidSelection}>
                        Edit
                    </button>
                </div>
            )}

            {/* SECOND TABLE */}

            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    {showEditTable && (
                        <>
                            <h5 className="mb-3 mt-3 innerheader-new">
                                <span>{typee === "additional" ? "Modified Additional Section" : "Additional Section"}</span>
                                {typee === "close" && (
                                    <>
                                        <h6 className="text-danger mt-2">These courses will be permanently closed and will not be available for future intake.</h6>
                                    </>
                                )}
                            </h5>
                            
                            <FieldArray name="courseChangeDetails">
                                {({ remove }) => (
                                    <div id="editTable" className="table-responsive">
                                        <table className="table table-hover align-middle mt-4">
                                            <thead className="table-primary">
                                                <tr className="small text-uppercase">
                                                    <th className="text-center">Sl.No</th>
                                                    <th>Academic Program Type</th>
                                                    <th>Name of the Single Major </th>
                                                    <th>Course / Branch</th>
                                                    <th>Section No.</th>

                                                    <th width="140px">Existing Intake</th>

                                                    {typee !== "close" && (
                                                        <>
                                                            <th>Add New Section</th>
                                                            {/* <th>Approval Fee</th> */}
                                                            <th width="140px">Revised Intake</th>
                                                        </>
                                                    )}
                                                    <th>Revised Section</th>
                                                    {/* <th>Type</th> */}
                                                    {/* <th width="180px">Nature</th> */}
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {values.courseChangeDetails.map((row, index) => (




                                                    <tr key={index}>
                                                        <>
                                                            {console.log("ROW DATA:", row)}
                                                        </>
                                                        <td className="text-center">{index + 1}</td>
                                                        {console.log("ROW DATA:", row)}
                                                        {/* <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_group_desc || ""}</td>

                            <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_cat_name || ""}</td>
                            <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_name || ""}</td> */}
                                                        <td>{courseData.find((c) => c.course_id == row.existing_course)?.course_group_desc || row.existing_stream_desc || "-"}</td>
                                                        <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_cat_name || row.existing_single_major_name || "-"}</td>
                                                        <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_name || row.existing_branch_name || "-"}</td>
                                                        {console.log("row.section_no", row)}
                                                        <td>
                                                            {/* {row.section_no || "-"} */}
                                                            {row.section_no ?? "-"}
                                                        </td>
                                                        <td>
                                                            <input value={row.existing_intake} className="form-control form-control-sm" disabled />
                                                        </td>

                                                        {/* <td>{row.section_no +row.</td> */}
                                                        {/* ✅ Proposed Change */}
                                                        {console.log("course state:", course)}
                                                        {typee !== "close" && (
                                                            <>
                                                                <td>
                                                                    {/* <Field as="select" name={`courseChangeDetails[${index}].proposed_change_name`} className="form-control form-control-sm" >
                                    <option value="">Select Course</option>
                                    <option value="newUgProgram">New UG programmes</option>
                                    <option value="additional">additional</option>
                                    <option value="withdrawal">withdrawal</option>
                                
                                  </Field> */}

                                                                    {/* <Field
                                                                        as="select"
                                                                        name={`courseChangeDetails[${index}].proposed_change_name`}
                                                                        className="form-control form-control-sm"
                                                                        // 
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                    >
                                                                        <option value="">--Select--</option>
                                                                        {[1, 2, 3].map((num) => (
                                                                            <option key={num} value={num}>
                                                                                {num}
                                                                            </option>
                                                                        ))}
                                                                    </Field> */}
                                                                    <Field
                                                                        as="select"
                                                                        name={`courseChangeDetails[${index}].proposed_change_name`}
                                                                        className="form-control form-control-sm"
                                                                        // onChange={(e) => {
                                                                        //     let total = 0;
                                                                        //     values.courseChangeDetails.forEach((row, idx) => {
                                                                        //         const sections = Number(row.section_no) || 1;
                                                                        //         const additional = idx === index ? Number(e.target.value) : (Number(row.proposed_change_name) || 0);
                                                                        //         total += sections + additional;
                                                                        //         console.log("total",total)
                                                                        //     });
                                                                        //     if (total <= 3) {
                                                                        //         formik.setFieldValue(`courseChangeDetails[${index}].proposed_change_name`, e.target.value);
                                                                        //     } else {
                                                                        //         Swal.fire({ icon: "warning", text: "Total sections cannot exceed 3" });
                                                                        //     }
                                                                        // }}
                                                                        onChange={(e) => {
                                                                            const newValue = Number(e.target.value);
                                                                            const currentTotal = values.courseChangeDetails.reduce((sum, row, idx) => {
                                                                                const existingValue = idx === index ? 0 : (Number(row.proposed_change_name) || 0);
                                                                                return sum + existingValue;
                                                                            }, 0);

                                                                            if (currentTotal + newValue <= 3) {
                                                                                formik.setFieldValue(`courseChangeDetails[${index}].proposed_change_name`, newValue);
                                                                            } else {
                                                                                Swal.fire({ icon: "warning", text: `Total sections across all courses cannot exceed 3. Available: ${3 - currentTotal}` });
                                                                            }
                                                                        }}
                                                                    >
                                                                        <option value="">--Select--</option>
                                                                        {[1, 2, 3].map(num => <option key={num} value={num}>{num}</option>)}
                                                                    </Field>
                                                                    {/* <ErrorMessage
                                    name={`courseChangeDetails[${index}].proposed_change_name`}
                                    component="div"
                                    className="text-danger small mt-1"
                                  /> */}
                                                                    {typee !== "close" && <ErrorMessage name={`courseChangeDetails[${index}].proposed_change_name`} component="div" className="text-danger small mt-1" />}
                                                                </td>
                                                                {/* Amount */}
                                                                {/* <td>
                                  <Field name={`courseChangeDetails[${index}].amount`} className="form-control form-control-sm" value="10000" />
                                </td> */}
                                                                {/* <td>
                                  {row.existing_intake }
                                </td> */}
                                                                <td>
                                                                    {
                                                                        (() => {
                                                                            const base = Number(row.existing_intake);
                                                                            const sections = Number(row.section_no) || 1;
                                                                            const extra = Number(row.proposed_change_name) || 0;
                                                                            return base && sections > 0 ? Math.round((base / sections) * (sections + extra)) : "-";
                                                                        })()
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <Field
                                                                        name={`courseChangeDetails[${index}].revised_intake`}
                                                                        className="form-control form-control-sm"
                                                                        value={(Number(row.section_no) || 0) + (Number(values.courseChangeDetails?.[index]?.proposed_change_name) || 0)}
                                                                        readOnly
                                                                    />
                                                                </td>

                                                                {/* <td>{typee === "additional" ? "Additional Sections" : ""}</td> */}
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => remove(index)}
                                                                    >
                                                                        <FaTrash />
                                                                    </button>
                                                                </td>
                                                            </>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </FieldArray>
                        </>
                    )}
                    {formik.values.courseChangeDetails.length > 0 && (
                        <jnb.Row className="mt-4">
                            <jnb.Col>
                                <div className="d-flex justify-content-end mt-4">
                                    <button className="btn btn-primary" type="submit">
                                        Submit
                                    </button>
                                </div>
                            </jnb.Col>
                        </jnb.Row>
                    )}
                    {/* <jnb.Row className="mt-4">
                        <jnb.Col>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </jnb.Col>
                    </jnb.Row> */}
                    {/* ) : mergeStatus ? ( */}
                    {/* <jnb.Row className="mt-4">
              <jnb.Col>
                <div className="d-flex justify-content-end mt-4">
                  <span className="text-success fw-bold">Already Submitted</span>
                </div>
              </jnb.Col>
            </jnb.Row> */}
                    {/* ) : null} */}
                </Form>
            </FormikProvider>


            {/* <FinancialResources type="Merger"  data={formik.values.courseChangeDetails}/> */}
            <style>{`
                .btn-icon { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; padding: 0; border-radius: 6px; }
                .extra-small { font-size: 0.75rem; }
                .table-dark { --bs-table-bg: #2d3436; }
                .form-control:focus, .form-select:focus { border-color: #74b9ff; box-shadow: 0 0 0 0.2rem rgba(116, 185, 255, 0.25); }
            `}</style>
        </>
    );
};

export default NewAdditonalSection;


